import { Vehicle } from '@cemex-core/cmx-api/models/vehicles/model/vehicle';
import {
  OneClickVehiclesActions,
  OneClickVehiclesActionTypes,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-vehicles.actions';

export interface OneClickVehiclesState {
  loading: boolean;
  vehiclesAvailable: Vehicle[];
  selected: Vehicle;
}

export const initialState: OneClickVehiclesState = {
  loading: false,
  vehiclesAvailable: [],
  selected: null,
};

export function reducer(state = initialState, action: OneClickVehiclesActions): OneClickVehiclesState {
  switch (action.type) {
    case OneClickVehiclesActionTypes.LOAD_VEHICLES: {
      return {
        ...state,
        loading: true,
      } as OneClickVehiclesState;
    }
    case OneClickVehiclesActionTypes.LOAD_VEHICLES_COMPLETE: {
      return {
        ...state,
        loading: false,
        vehiclesAvailable: action.payload,
      } as OneClickVehiclesState;
    }
    case OneClickVehiclesActionTypes.SELECT_VEHICLE: {
      return {
        ...state,
        selected: action.payload,
      } as OneClickVehiclesState;
    }
    case OneClickVehiclesActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
